var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92308 1.04808C6.92308 0.5375 6.51058 0.125 6 0.125C5.48942 0.125 5.07692 0.5375 5.07692 1.04808V5.20192H0.923077C0.4125 5.20192 0 5.61442 0 6.125C0 6.63558 0.4125 7.04808 0.923077 7.04808H5.07692V11.2019C5.07692 11.7125 5.48942 12.125 6 12.125C6.51058 12.125 6.92308 11.7125 6.92308 11.2019V7.04808H11.0769C11.5875 7.04808 12 6.63558 12 6.125C12 5.61442 11.5875 5.20192 11.0769 5.20192H6.92308V1.04808Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSolid);
export default __webpack_public_path__ + "static/media/plus-solid.a5acd93cbae64b4e53216e320202e531.svg";
export { ForwardRef as ReactComponent };